import { Card, Col, notification, Row, Statistic } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAreaScope } from "../actions";
import { coreApi } from "../api/calls";
import ClientAddForm from "../components/Clients/ClientAddForm";
import ClientsList from "../components/Clients/ClientsList";
import { useHistory } from 'react-router-dom';

const gutter = [16, 24];

const ClientsIndex = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const areaScope = useSelector(getAreaScope);
  const selectedCity = areaScope.areaScope;

  const [isLoading, setLoading] = useState(false);

  const [clientsList, setClientsList] = useState([]);
  const [pagination, setPagination] = useState({});

  const [stats, setStats] = useState({});

  const [filters, setFilters] = useState({
    date_from: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
    date_to: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
  });

  const [duplicity, setDuplicity] = useState(false);

  const [duplicateClient, setDuplicateClient] = useState({});

  useEffect(() => {
    setLoading(true);

    axios
      .all([
        coreApi.get("/clients", {
          params: {
            ...filters,
            city_branch_id: selectedCity,
          },
        }),
        coreApi.get("/clients/basic-stats", {
          params: { city_branch_id: selectedCity },
        }),
      ])
      .then(
        axios.spread((clients, basicStats) => {
          let { data, ...pagination } = clients.data;
          setPagination(pagination);
          setClientsList(data);

          setStats(basicStats.data);
        })
      )
      .catch((err) => notification.error({ message: err.response.data.message }))
      .finally(() => setLoading(false));
  }, [filters, selectedCity]);

  const addClient = (values) => {
    coreApi
      .post("/clients", values)
      .then((response) => {
        setClientsList([response.data.client, ...clientsList]);
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('new')) {
          history.push('/clients/' + response.data.client.id);
        }
      })
      .catch((error) => {
        notification.error({ message: error?.response?.data?.message });
      });
  };

  const checkDuplicity = (values) => {
    setDuplicity(false);
    coreApi
      .get("/clients/check-duplicity", { params: { ...values } })
      .then((res) => {
        setDuplicity(false);
      })
      .catch((err) => {
        setDuplicateClient({ ...err.response.data.client });
        setDuplicity(true);
      });
  };

  /**
   * Recalculates balance of client.
   *
   * @param {int} clientId - id of the client
   */

  return (
    <React.Fragment>
      <Row gutter={gutter}>
        {/*<Col span={6}>
          <Card>
            <Statistic loading={isLoading} title={t("clients.activeClients")} value={stats?.count}></Statistic>
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic loading={isLoading} title={t("clients.newClients")} value={stats?.new}></Statistic>
          </Card>
        </Col>
        <Col span={6}></Col>
        <Col span={6}></Col>*/}
        <Col span={24}>
          <Card>
            <ClientsList
              clientsList={clientsList}
              isLoading={isLoading}
              pagination={pagination}
              filters={filters}
              setFilters={setFilters}
            ></ClientsList>
          </Card>
        </Col>
        <Col span={24}>
          <ClientAddForm
            addClient={addClient}
            checkDuplicity={checkDuplicity}
            duplicity={duplicity}
            duplicateClient={duplicateClient}
          ></ClientAddForm>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ClientsIndex;
